import { authHeader } from '../_helpers'
import { settings } from '../settings'

export const customerService = {
  logout,
  getAll
}

function logout () {
  // remove user from local storage to log user out
  localStorage.removeItem('user')
}

function getAll (rows, page, sortby, descending) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }
  console.log(rows)
  const r = '?items_per_page=' + rows + '&page=' + page + '&orderby=' + sortby + '&desc=' + descending

  return fetch(`${settings.apiUrl}/customers/` + r, requestOptions)
    .then(handleResponse)
}

function handleResponse (response) {
  return response.json().then(json => {
    const data = json
    if (!response.ok) {
      if (response.status === 401) {
        logout()
        location.reload(true)
      }

      const error = (data && data.message) || response.statusText
      return Promise.reject(error)
    }
    return Promise.resolve(data)
  })
}
